<script lang="ts" setup>
  import { useAuthenticated } from '@othercommerce/foundation';

  const authenticated = useAuthenticated();
</script>
<template>
  <div v-if="authenticated && authenticated.b2b" class="customer-credit">
    <h2>
      {{ $t('SHOP.ORDER.HEADER.CUSTOMER_CREDIT') }}
    </h2>
    <dl>
      <div class="group">
        <dt>
          {{ $t('SHOP.ORDER.LABEL.CUSTOMER_CREDIT') }}
        </dt>
        <dd>
          <SfMoney :value="authenticated.credit" />
        </dd>
      </div>
      <div v-if="authenticated.creditLimit" class="group">
        <dt>
          {{ $t('SHOP.ORDER.LABEL.CUSTOMER_CREDIT_LIMIT') }}
        </dt>
        <dd>
          <SfMoney :value="authenticated.creditLimit" />
        </dd>
      </div>
    </dl>
  </div>
</template>
<style lang="scss" scoped>
  .customer-credit {
    font-size: 0.875rem;
    border: 1px solid transparent;

    h2 {
      font-size: 1.25rem;
      margin-bottom: 1rem;
    }

    dl {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 1rem;
      row-gap: 0.25rem;

      dd {
        font-weight: bold;
      }
    }
  }
</style>
